import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormMode } from 'app/core/constants/form-mode';

@Component({
  selector: 'app-doc-ref-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './doc-ref-form.component.html'
})
export class DocRefFormComponent {
  documentTypeForm = input.required<FormGroup>();
  mode = input<FormMode>(FormMode.CREATE);
  formMode = FormMode;
}
